<script>
    import {onMount} from "svelte";
    import AssessmentNav from "./Components/AssessmentNav.svelte";
    import Assessment from './Models/assessmentModel';
    import Loader from './Components/Loader.svelte';
    import {addFormModal} from './Forms/ModalFormManager.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {confirm} from './Components/Confirmation.svelte';

    import {forms} from './lib/forms'

    import {assessment_type_categories} from './lib/assessment_type_categories';
    import SortableTable from './Components/SortableTable.svelte';


    export let params;

    let assessment_model;
    let assessment;

    let recommendations = [];

    function loadRecommendations(assessment_data) {
        if (!assessment_data) return;
        recommendations = [];
        for (let category_recommendations of Object.values(assessment_data.recommendations)) {
            recommendations = [...recommendations, ...category_recommendations];
        }
    }

    $: loadRecommendations($assessment);

    function editRecommendation(recommendation) {
        addFormModal({
            fields: forms['recommendation'],
            data: recommendation
        }).then(formData => {
            assessment_model.updateRecommendation(formData).then(() => notifier.success("Recommendation Saved"));
        }).catch(() => null)
    }

    function deleteRecommendation(recommendation) {
        confirm("Are you sure you want to delete this recommendation?").then(
            () => {
                assessment_model.deleteRecommendation(recommendation)
            }
        ).catch(() => null)
    }

    onMount(() => {
        assessment_model = new Assessment(params.id);
        assessment = assessment_model.store;
    })
</script>

<Loader loading={!$assessment.details}>
    <div class="columns">
        <div class="column is-3">
            <AssessmentNav assessment_id={$assessment.details._id} />
            <span></span>
        </div>
    </div>

    <div class="column">
        <SortableTable sortFields={assessment_type_categories[$assessment.assessment_type_data.assessment_type_category || "Risk Assessment"].tables['recommendations']} tableData={recommendations} tableClass="NISTTable">
            <div slot="rowActions" let:row={recommendation}>
                <div class="buttons">
                    <div class="button is-primary" on:click={() => editRecommendation(recommendation)}>Edit</div>
                    <div class="button is-danger" on:click={() => deleteRecommendation(recommendation)}>Delete</div>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>

<style>
    .columns {
        margin: 0;
        padding:0;
    }
</style>